module.exports = require("lq-form");